import React from 'react';

import { type ModalInnerProps } from '@/hooks/common/useModal';

import UnlinkConfirmModal from './UnlinkConfirmModal';

interface Props extends ModalInnerProps {
  studentName: string;
  parentId: number;
  code: string;
}

const UnlinkSelfConfirmModal: React.FC<Props> = ({
  isOpen,
  toggle,
  studentName,
  parentId,
  code,
}) => (
  <UnlinkConfirmModal
    isOpen={isOpen}
    toggle={toggle}
    parentId={parentId}
    code={code}
    targetName={studentName}
    showNotifyEmailNotice={false}
    description={
      <>
        この操作は取り消せません。
        <br />
        生徒や紐付く保護者の情報が見れなくなります。
        <br />
        また、紐付く生徒が0人になると、翌日には自動的にアカウントが削除されます。
      </>
    }
  />
);

export default UnlinkSelfConfirmModal;
